/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Corporate } from '../../models/corporate';
import { CorporateApiRespModel } from '../../models/corporate-api-resp-model';

export interface ApiMasterCorporateAddPost$Params {
      body?: Corporate
}

export function apiMasterCorporateAddPost(http: HttpClient, rootUrl: string, params?: ApiMasterCorporateAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CorporateApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiMasterCorporateAddPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CorporateApiRespModel>;
    })
  );
}

apiMasterCorporateAddPost.PATH = '/api/Master/Corporate/Add';
